import React, {useState, useEffect} from 'react'

import classes from './CatalogueListItem.module.css'
import clsx from 'clsx';
import SoundPlayer from 'react-sdk/SoundPlayer';

const CatalogueListItem = ({item, selected, children, onClick}) => {
  function handleClick(e) {
    e.stopPropagation()
    
    if(item.locked) return
    SoundPlayer.playSound("click")

    onClick(item)
  }
  return (
    <div className={clsx(classes.CatalogueListItem, !item.locked && classes.unlocked, selected && classes.selected)} >
      <div className={clsx(
      classes.titre,
      item.knowledge > 0 && classes.good,
      item.knowledge < 0 && classes.bad)} onClick={handleClick}>

        {item.titre}
      </div>
      {children}
    </div>
  );
};

export default CatalogueListItem;
